import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";

export function PlaygroundSectionPlaybook() {
  return (
    <Section data-test="playbook-section">
      <div className="flex items-center gap-2">
        <SectionHeader>
          <SectionTitle>Discovery playbook summary</SectionTitle>
        </SectionHeader>
      </div>

      <div className="flex flex-col rounded-md bg-muted p-4">
        <p>Did the rep introduce themselves?</p>
        <p>Were the prospect's pain points captured?</p>
        <p>Was a clear next step agreed upon?</p>
      </div>
    </Section>
  );
}
